import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from './ToastContext';
import './PackagesDashboard.css';

const PackagesDashboard = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [packages, setPackages] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const API_BASE_URL = 'https://eks-projectmanager.eksconstruction.in/api';

  const fetchPackages = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/get_packages.php`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();

      if (result.success && result.packages) {
        setPackages(result.packages);
      } else {
        setPackages([]);
      }
    } catch (error) {
      showToast && showToast({ message: 'Error fetching packages: ' + error.message, type: 'error' });
      setPackages([]);
    } finally {
      setIsLoading(false);
    }
  }, [showToast]);

  useEffect(() => {
    fetchPackages();
  }, [fetchPackages]);

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div className="header-content">
          <div className="header-left">
            <div className="header-icon-large">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M20 7h-9m0 10h9M5 7h.01M5 17h.01M9 7a2 2 0 11-4 0 2 2 0 014 0zM9 17a2 2 0 11-4 0 2 2 0 014 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div>
              <h1>Packages Dashboard</h1>
              <p className="header-subtitle">Manage pricing and specifications for your website's packages page</p>
            </div>
          </div>
          <div className="header-buttons">
            <button className="gallery-nav-btn" onClick={() => navigate('/dashboard')}>
              Projects
            </button>
          </div>
        </div>
      </div>

      {isLoading && (
        <div style={{ textAlign: 'center', padding: '60px 20px', fontSize: '18px', color: '#718096' }}>
          Loading packages...
        </div>
      )}

      {!isLoading && (
        <div className="packages-grid-admin">
          {packages.map(pkg => (
            <div key={pkg.id} className={`package-card-admin ${pkg.color}`}>
              {pkg.popular ? <div className="popular-badge">MOST POPULAR</div> : null}
              <h3>{pkg.title}</h3>
              <div className="package-price-admin">
                <span className="currency">₹</span>
                <span className="amount">{pkg.price}</span>
                <span className="unit">per sqft</span>
              </div>
              <p className="package-key-label">key: {pkg.package_key}</p>
              <button className="edit-btn-admin" onClick={() => navigate(`/packages/${pkg.id}/edit`)}>
                Edit Package
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PackagesDashboard;
